import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Showcase } from 'features/Showcase'
import { ProductCardContainer } from 'Catalog/Product/ProductCard'

class ItemToItem extends Component {
  componentDidMount () {
    const productId = this.props.productId

    this.props.fetchItemToItemRecomendation(productId)
  }

  render () {
    return (
      this.props.products.length > 0 && (
        <Showcase
          title={this.props.title}
          mobileTitle={this.props.titleMobile}
          isLoading={!(this.props.products.length > 0)}
          viewAllPath='/search'
        >
          { this.props.products.map((p, idx) => (
            <ProductCardContainer {...p} key={p.sku}
              className='col-12 px-auto px-md-0 mb-2 mb-md-0'
              sku={p.sku} />
          )) }
        </Showcase>
      )
    )
  }
}

ItemToItem.propTypes = {
  fetchItemToItemRecomendation: PropTypes.func,
  addItemToCart: PropTypes.func,
  email: PropTypes.string,
  title: PropTypes.string,
  titleMobile: PropTypes.string,
  productId: PropTypes.number,
  products: PropTypes.array,
  isLoading: PropTypes.bool,
  cart: PropTypes.object,
  onlyCash: PropTypes.bool,
  currencyConfiguration: PropTypes.object
}

const mapStateToProps = ({ oidc, cart, onlyCash, catalog }) => ({
  email: oidc && oidc.user && oidc.user.profile && oidc.user.profile.email,
  cart,
  onlyCash,
  currencyConfiguration: catalog.currencyConfiguration
})

export default connect(
  mapStateToProps
)(ItemToItem)



// WEBPACK FOOTER //
// ./src/features/Recomendation/ItemToItem/ItemToItem.js